"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// IE11 does not support File constructor
// File is just a Blob with lastModifiedDate and name properties
exports.createFile = function (_a) {
    var blobPart = _a.blobPart, filename = _a.filename, contentType = _a.contentType;
    var _b;
    var file;
    if ((_b = window === null || window === void 0 ? void 0 : window.navigator) === null || _b === void 0 ? void 0 : _b.msSaveOrOpenBlob) {
        file = new Blob([blobPart], { type: contentType });
        // @ts-ignore
        file.lastModifiedDate = new Date();
        // @ts-ignore
        file.name = filename;
    }
    else {
        file = new File([blobPart], filename);
    }
    return file;
};
//# sourceMappingURL=FileUtil.js.map